import _ from 'lodash'

import { getEventGroups, getVenues, getMarkets, getSetupforms } from 'selectors/entities'
import { PAST_PERFORMANCES_CUTOFF_HOUR } from 'selectors/event-group'
import { createDeepEqualSelector } from 'utils/selectors'
import { getPrevHour, isAfter, sort } from 'utils/datetime'
import { REVIEW_STATUS } from 'constants/setupform-constants'

export const getEventGroupsByPartnerId = partnerId => state =>
  Object.values(getEventGroups(state)).filter(eventGroup => (
    (eventGroup.partner && eventGroup.partner.id === Number(partnerId)) ||
    (eventGroup.alternatePayee && eventGroup.alternatePayee.id === Number(partnerId))
  ))

export const getSetupformsByPartnerId = partnerId => state =>
  Object.values(getSetupforms(state)).filter(setupform => setupform.partnerId === Number(partnerId))

const denormalize = (venues, markets, entity) => ({
  ...entity,
  market: markets[entity.market],
  venue: venues[entity.venue],
})

export const mapEventGroups = (past = false) => (eventGroups, venues, markets) =>
  (!_.isEmpty(eventGroups) && !_.isEmpty(venues) && !_.isEmpty(markets) ? Object.values(eventGroups)
    .filter(eventGroup => {
      const cutOff = getPrevHour(PAST_PERFORMANCES_CUTOFF_HOUR)
      return past ? !isAfter(eventGroup.lastStartTime, cutOff) : isAfter(eventGroup.lastStartTime, cutOff)
    })
    .map(denormalize.bind(null, venues, markets))
    .sort(past ? (a, b) => sort(b.lastStartTime, a.lastStartTime) : (a, b) => sort(a.nextStartTime, b.nextStartTime))
  : [])

export const getEventGroupsWithVenues = _.memoize(partnerId => createDeepEqualSelector(
  [getEventGroupsByPartnerId(partnerId), getVenues, getMarkets],
  mapEventGroups()
))

export const getPastEventGroupsWithVenues = _.memoize(partnerId => createDeepEqualSelector(
  [getEventGroupsByPartnerId(partnerId), getVenues, getMarkets],
  mapEventGroups(true)
))

export const mapSetupforms = (submitted = false) => (setupforms, venues, markets) =>
  (!_.isEmpty(setupforms) && !_.isEmpty(venues) && !_.isEmpty(markets) ? Object.values(setupforms)
    .filter(setupform => {
      const reviewStatus = submitted ? REVIEW_STATUS.SUBMITTED : REVIEW_STATUS.DRAFTS
      return setupform.reviewStatus === reviewStatus
    })
    .map(denormalize.bind(null, venues, markets))
  : [])

export const getDraftSetupforms = _.memoize(partnerId => createDeepEqualSelector(
  [getSetupformsByPartnerId(partnerId), getVenues, getMarkets],
  mapSetupforms()
))

export const getSubmittedSetupforms = _.memoize(partnerId => createDeepEqualSelector(
  [getSetupformsByPartnerId(partnerId), getVenues, getMarkets],
  mapSetupforms(true)
))

export const isFetchingEventGroups = state => state.pages.homePage.isFetchingEventGroups
export const isFetchingSetupforms = state => state.pages.homePage.isFetchingSetupforms



/** WEBPACK FOOTER **
 ** ./src/selectors/home/home-selectors.js
 **/